import { render, staticRenderFns } from "./CircleChartSmall.vue?vue&type=template&id=559a2b01"
import script from "./CircleChartSmall.vue?vue&type=script&lang=js"
export * from "./CircleChartSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports